import React from 'react'
import Markdown from 'react-markdown'

type MarkdownFormattedTextProps = {
  text: string
}

export const MarkdownFormattedText = ({ text }: MarkdownFormattedTextProps): JSX.Element => {
  return <Markdown>{text}</Markdown>
}
